module.exports = "/_next/static/images/south-florida-fast-channel-description-image-black-letters-f42145ca35e222b7a2a4da4ac03bcc38.svg";